import { FC } from 'react';
import renderRoutes from 'router/renderRoutes';
import { authRoutes, routes } from 'router/routes';
import { useAppSelector } from 'hooks/redux';
import { Header } from 'components/common';

import s from './styles.module.scss';

const WithAuthContent: FC = () => {
	const isAuth = useAppSelector((state) => state.user.isAuth);

	if (isAuth)
		return (
			<>
				<Header />
				<div className={s.container}>{renderRoutes(routes)}</div>
			</>
		);

	return renderRoutes(authRoutes);
};

export default WithAuthContent;
